import faker from 'faker';
import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { useEffect, useRef, useState } from 'react';
import micFill from '@iconify/icons-eva/mic-fill';
import roundSend from '@iconify/icons-ic/round-send';
import attach2Fill from '@iconify/icons-eva/attach-2-fill';
import roundAddPhotoAlternate from '@iconify/icons-ic/round-add-photo-alternate';
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { Divider, IconButton, Stack, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button} from '@material-ui/core';
import EmojiPickerChatSignWise from 'src/components/EmojiPickerChatSignWise';
import { DOMAIN } from 'src/constants/Defaultvalues';
// import { io } from "socket.io-client"; // OLD
// import { DOMAIN, REST_API_IO } from 'src/constants/Defaultvalues'; // OLD
import createAppSocket from 'src/Helpers/createSocket';
import { useSnackbar } from 'notistack';
import { ref as imageref, uploadBytesResumable, getDownloadURL } from '@firebase/storage';
import { storage } from 'src/firebase/firebase';
import ReactQuill from 'react-quill';
import { supabase } from '../../../../supabase/supabaseClient';

const RootStyle = styled('div')(({ theme }) => ({
  minHeight: 75,
  maxHeight: 75,
  minWidth:400,
  maxWidth:400,
  display: 'flex',
  position: 'relative',
  alignItems: 'center',
  justifyContent:'center',
  paddingLeft: theme.spacing(2),
  width: '100%',
  '& .ql-toolbar': {
    border: 'none !important',
    padding: '4px !important',
    maxHeight: '20px',
    display: 'flex',
    alignItems: 'center',
  },
  '& .ql-container': {
    border: 'none !important',
    fontSize: '14px',
    position: 'relative !important', 
  },
  // '& .ql-editor': {
  //   maxHeight: '60px',
  //   overflowY: 'auto',
  //   whiteSpace: 'pre-wrap',
  //   wordBreak: 'break-word',
  //   padding: '4px !important',
  //   scrollbarWidth: 'thin', 
  //   scrollbarColor: ' #1a1a1a',
  //   // display: 'flex',
  //   // flexWrap: 'wrap',
  //   // alignItems: 'center',
  // },
  '& .ql-editor': {
  minHeight: '38px',
  maxHeight: '100px',        // ⬅️ grows up to ~5 lines
  overflowY: 'auto',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  padding: '6px 8px',
},
  '& .ql-toolbar button': {
    width: '15px',
    height: '15px',
    padding: '2px',
    color: '#d3d3d3!important',
  },
  '& .ql-toolbar button svg': {
    width: '16px',
    height: '16px',
  },
  '& .ql-toolbar button:hover': {
    color: '#1ccaff !important', 
  },
  '& .ql-toolbar .ql-active': {
    color: '#1ccaff !important', 
  },
  '& .ql-editor::before': {
    color: '#d3d3d3 !important',
    fontStyle: 'normal !important',
    fontSize:'14px !important'
  },
  '& .ql-tooltip': {
    zIndex: 1050,
    position: 'absolute !important',
    left: '50% !important',
    transform: 'translateX(-50%) !important',
    top: '-40px !important',
    backgroundColor: 'var(--signwise-app-chrome-main) !important',
    color: 'white !important',
    padding: '6px 8px !important',
    borderRadius: '6px !important',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.2) !important',
    border: '1px solid #555 !important',
    fontSize: '12px !important', 
  },

  '& .ql-tooltip input': {
    backgroundColor: 'var(--signwise-app-chrome-main) !important', 
    color: '#f5f5f5 !important',
    padding: '4px !important',
    borderRadius: '4px !important',
    border: '1px solid #555 !important',
    outline: 'none !important',
  },

  '& .ql-tooltip a.ql-action': {
    color: '#1ccaff !important',
  },

  '& .ql-tooltip a.ql-remove': {
    color: '#ff4d4d !important',
  },


}));



ChatMessageInputSignWise.propTypes = {
  disabled: PropTypes.bool,
  conversationId: PropTypes.string,
  onSend: PropTypes.func
};

export default function ChatMessageInputSignWise({
  selectedChatLogId,disabled, handleRefresh, refreshChat, setRenderChat, renderChat, 
  message, setMessage, image, setImage, fetchMessages, conversationId, messages, setMessages,
  onSend, onEdit, editingMessage, onCancelEdit, chat, setChat, isTyping, setIsTyping, typingUser, setTypingUser,setOnChatScreen,participants, ...other
}) {
  const fileInputRef = useRef(null);
  const [progress, setProgress] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  let user = JSON.parse(localStorage.getItem('user'));
  let updatedUserId = `user_${user.user_id}`;
  const typingTimeout = useRef(null);
  const socketRef = useRef(null);
  const [openImagePreview, setOpenImagePreview] = useState(false);
  const [imagePreview, setImagePreview] = useState('');
  const quillRef = useRef(null);


useEffect(() => {
  const editorRoot = quillRef.current?.editor?.root;

  // const handlePaste = async (e) => {
  //   if (!e.clipboardData) return;

  //   const items = e.clipboardData.items;
  //   for (let i = 0; i < items.length; i++) {
  //     const item = items[i];

  //     // 🔐 Intercept image paste
  //     if (item.type.indexOf("image") !== -1) {
  //       e.preventDefault(); // 🔥 Prevent Quill from inserting base64

  //       const file = item.getAsFile();
  //       if (file) {
  //         const filename = `${Date.now()}_${file.name.replace(/\s+/g, '_')}`;
  //         const filePath = `chat-signwise/attachments/${filename}`;

  //         try {
  //           setProgress(true);

  //           const { error: uploadError } = await supabase.storage
  //             .from('signwise-attachments')
  //             .upload(filePath, file);
  //           if (uploadError) throw uploadError;

  //           const { data: publicUrlData, error: urlError } = supabase.storage
  //             .from('signwise-attachments')
  //             .getPublicUrl(filePath);

  //           if (urlError || !publicUrlData?.publicUrl) {
  //             throw new Error('Failed to get public URL');
  //           }

  //           const imageUrl = publicUrlData.publicUrl;

  //           // Open modal with uploaded image
  //           setImagePreview(imageUrl);
  //           setImage(imageUrl);
  //           setOpenImagePreview(true);
  //           setProgress(false);
  //         } catch (error) {
  //           console.error("Image paste failed:", error.message);
  //           enqueueSnackbar("Image paste failed", { variant: "error" });
  //           setProgress(false);
  //         }
  //       }
  //     }
  //   }
  // };

  const handlePaste = async (e) => {
  if (!e.clipboardData) return;

  const items = e.clipboardData.items;
  for (let i = 0; i < items.length; i++) {
    const item = items[i];

    if (item.type.indexOf("image") !== -1) {
      e.preventDefault();

      const file = item.getAsFile();
      if (file) {
        const filename = `${Date.now()}_${file.name.replace(/\s+/g, '_')}`;
        const filePath = `chat-signwise/attachments/${filename}`;

        try {
          setProgress(true);

          const { error: uploadError } = await supabase.storage
            .from('signwise-attachments')
            .upload(filePath, file);
          if (uploadError) throw uploadError;

          const { data: publicUrlData, error: urlError } = supabase.storage
            .from('signwise-attachments')
            .getPublicUrl(filePath);

          if (urlError || !publicUrlData?.publicUrl) {
            throw new Error('Failed to get public URL');
          }

          const imageUrl = publicUrlData.publicUrl;

          // ✅ Insert image at cursor position
            const quill = quillRef.current.getEditor();
            const range = quill.getSelection(true);
            const insertAt = range ? range.index : quill.getLength();

            quill.insertEmbed(insertAt, 'image', imageUrl);        // paste image
            quill.insertText(insertAt + 1, '\n');                  // add newline
            quill.insertText(insertAt + 2, '\n');                  // optional: more space
            quill.setSelection(insertAt + 3);                      // place cursor below


          setProgress(false);
        } catch (error) {
          console.error("Image paste failed:", error.message);
          enqueueSnackbar("Image paste failed", { variant: "error" });
          setProgress(false);
        }
      }
    }
  }
};

  editorRoot?.addEventListener("paste", handlePaste);
  return () => {
    editorRoot?.removeEventListener("paste", handlePaste);
  };
}, []);

  // When sender enters edit mode, stop "typing" so receiver does not get a fake typing bubble
  useEffect(() => {
    if (!editingMessage?.id || !socketRef.current) return;
    clearTimeout(typingTimeout.current);
    socketRef.current.emit("stop typing", {
      conversationId,
      senderId: user.user_id,
      participants,
      domain: DOMAIN
    });
  }, [editingMessage?.id]);



  useEffect(() => {
    let notificationSound = new Audio('/sounds/whatsapp_tone.mp3');
    if(user.user_id===667){
      notificationSound = new Audio('/sounds/barking_dog.mp3');
    }
    // OLD CODE (keep for future restore):
    // socketRef.current = io(REST_API_IO, { path: "/socket.io", transports: ["websocket", "polling"], secure: true });
    socketRef.current = createAppSocket();

    socketRef.current.on("message", (msg) => {
     if(msg?.domain===DOMAIN){ setOnChatScreen(false)
      const currentUserId = user?.user_id;
      let receivedConversationId = String(msg.conversationId);
      let senderConversationId = String(msg.senderId);
      const isGroupChat = Array.isArray(msg.participants) && msg.participants.length > 0;
  const isOwnMessage = senderConversationId === String(currentUserId);
      if (conversationId.startsWith("user_")) {
        if (!receivedConversationId.startsWith("user_")) receivedConversationId = `user_${receivedConversationId}`;
        if (!senderConversationId.startsWith("user_")) senderConversationId = `user_${senderConversationId}`;
      }
      let isSameConversation = false;
      let isRecipientInGroup = true;
      if (isGroupChat) {
        const participantIds = msg.participants.map(p => p.user_id);
        isRecipientInGroup = participantIds.includes(currentUserId);
        isSameConversation = receivedConversationId === conversationId;
      } else {
        // 1-on-1 chat logic
        isSameConversation =
          receivedConversationId === updatedUserId && senderConversationId === conversationId;
          
      }
      // if (receivedConversationId === updatedUserId || receivedConversationId === conversationId || senderConversationId === conversationId) {
        if (isSameConversation && isRecipientInGroup ) {
          if (
              selectedChatLogId != null &&
              msg.selectedChatLogId != null &&
              msg.selectedChatLogId === selectedChatLogId
            ) {
              setChat((prev) => [...prev, msg]);
            }

        // if (receivedConversationId === conversationId) {
        // if (receivedConversationId === updatedUserId  && msg.senderId !== updatedUserId ) {
          // notificationSound.play().catch((e) => console.error("Failed to play sound:", e));
          if (!isOwnMessage) {
            try {
              notificationSound.play();
            } catch (e) {
              console.error("Failed to play sound:", e);
            }
          }
          fetchMessages(conversationId);
          setRenderChat(!renderChat);
          handleRefresh();
        // } else {
        //   setTimeout(() => {
        //     // notificationSound.play().catch((e) => console.error("Failed to play sound:", e));
        //     fetchMessages(conversationId);
        //     setRenderChat(!renderChat);
        //     handleRefresh();
        //   }, 1000);
        // }
      }
    }
    });

    socketRef.current.on("edit-message", (data) => {
      if (data?.domain !== DOMAIN) return;

      const currentUserId = user?.user_id;
      let receivedConversationId = String(data.conversationId);
      let senderConversationId = String(data.senderId);
      const isGroupChat = Array.isArray(data.participants) && data.participants.length > 0;

      if (conversationId.startsWith("user_")) {
        if (!receivedConversationId.startsWith("user_")) receivedConversationId = `user_${receivedConversationId}`;
        if (!senderConversationId.startsWith("user_")) senderConversationId = `user_${senderConversationId}`;
      }

      let isSameConversation = false;
      let isRecipientInGroup = true;

      if (isGroupChat) {
        const participantIds = data.participants.map((p) => p.user_id);
        isRecipientInGroup = participantIds.includes(currentUserId);
        isSameConversation = receivedConversationId === conversationId;
      } else {
        // 1-on-1: match both directions (sender/receiver)
        isSameConversation =
          (receivedConversationId === updatedUserId && senderConversationId === conversationId) ||
          (receivedConversationId === conversationId && senderConversationId === updatedUserId);
      }

      if (
        isSameConversation &&
        isRecipientInGroup &&
        selectedChatLogId != null &&
        data.selectedChatLogId != null &&
        data.selectedChatLogId === selectedChatLogId
      ) {
        const targetId = data.messageId != null ? Number(data.messageId) : null;
        if (typeof setMessages === 'function') {
          setMessages((prev) =>
            (Array.isArray(prev) ? prev : []).map((m) => {
              const same =
                targetId != null &&
                !Number.isNaN(targetId) &&
                Number(m.id) === targetId;
              return same ? { ...m, text: data.message } : m;
            })
          );
        } else {
          fetchMessages(conversationId);
        }
      }
    });

    socketRef.current.on("typing", (data) => {
      if(data?.domain===DOMAIN){
      let receivedConversationId = String(data.conversationId);
      let senderConversationId = String(data.senderId);
      let senderId = String(data.senderId);
      const currentUserId = user?.user_id;
      const isGroupChat = Array.isArray(data.participants);
      if (conversationId.startsWith("user_")) {
        if (!receivedConversationId.startsWith("user_")) receivedConversationId = `user_${receivedConversationId}`;
        if (!senderConversationId.startsWith("user_")) senderConversationId = `user_${senderConversationId}`;
      }
      if (isGroupChat && data.participants.length > 0) {
        const participantIds = data.participants.map(p => p.user_id);
        const isRecipient = participantIds.includes(currentUserId);       
        if (
          isRecipient &&
          senderId !== currentUserId &&
          receivedConversationId === conversationId && data.selectedChatLogId === selectedChatLogId
        ) {
          setTypingUser(data.user);
          setIsTyping(true);
        }
      } else {
      // if (receivedConversationId === updatedUserId  ) {
     
     if(
      // (receivedConversationId === conversationId || senderConversationId === conversationId) &&
      receivedConversationId === updatedUserId && senderConversationId === conversationId
      && data.senderId !== updatedUserId && data.selectedChatLogId === selectedChatLogId
    ) {

        setTypingUser(data.user);
        setIsTyping(true);
      }
    }
  }
    });
    // socketRef.current.on("typing", (data) => {
    //   console.log('data++++++++++++++++++++', data);
    
    //   let receivedConversationId = String(data.conversationId);
    //   let senderId = String(data.senderId);
    //   const isGroupChat = Array.isArray(data.participants);
    //   const currentUserId = user?.user_id;
    
    //   // Check for group chat
    //   if (isGroupChat && data.participants.length > 0) {
    //     const participantIds = data.participants.map(p => p.user_id);
    //     const isRecipient = participantIds.includes(currentUserId);
    
    //     if (
    //       isRecipient &&
    //       senderId !== currentUserId &&
    //       receivedConversationId === conversationId
    //     ) {
    //       setTypingUser(data.user);
    //       setIsTyping(true);
    //     }
    //   } else {
    //     // For one-to-one chat fallback
    //     let normalizedReceivedId = receivedConversationId;
    //     let normalizedSenderId = String(senderId);
    
    //     if (conversationId.startsWith("user_")) {
    //       if (!normalizedReceivedId.startsWith("user_")) normalizedReceivedId = `user_${normalizedReceivedId}`;
    //       if (!normalizedSenderId.startsWith("user_")) normalizedSenderId = `user_${normalizedSenderId}`;
    //     }
    
    //     if (
    //       normalizedReceivedId === currentUserId &&
    //       senderId !== currentUserId
    //     ) {
    //       setTypingUser(data.user);
    //       setIsTyping(true);
    //     }
    //   }
    // });
    
    socketRef.current.on("stop typing", (data) => {
      if(data?.domain===DOMAIN){
        let receivedConversationId = String(data.conversationId);
      let senderConversationId = String(data.senderId);
      const senderId = String(data.senderId);
      const currentUserId = user?.user_id;
      const isGroupChat = Array.isArray(data.participants);
      if (conversationId.startsWith("user_")) {
        if (!receivedConversationId.startsWith("user_")) receivedConversationId = `user_${receivedConversationId}`;
        if (!senderConversationId.startsWith("user_")) senderConversationId = `user_${senderConversationId}`;
      }
      if (isGroupChat && data.participants.length > 0) {
        const participantIds = data.participants.map(p => p.user_id);
        const isRecipient = participantIds.includes(currentUserId);
    
        if (
          isRecipient &&
          senderId !== currentUserId &&
          receivedConversationId === conversationId
        ) {
          setIsTyping(false);
        }
      } else {
      // if ((receivedConversationId === conversationId || senderConversationId === conversationId)&& data.senderId !== user.user_id) {
        if (
          receivedConversationId === updatedUserId &&
          senderId !== updatedUserId
        ) {
        setIsTyping(false);
      }
    }}
    });

    return () => {
      socketRef.current.disconnect();
    };
  }, [conversationId]);

  const handleTyping = () => {
    if (!socketRef.current) return;
    socketRef.current.emit("typing", { user, conversationId, senderId: user.user_id,participants,selectedChatLogId,domain:DOMAIN });
    if (typingTimeout.current) clearTimeout(typingTimeout.current);
    typingTimeout.current = setTimeout(() => {
      socketRef.current?.emit("stop typing", { conversationId, senderId: user.user_id,participants,domian:DOMAIN });
    }, 2000);
  };

  const handleAttach = () => {
    fileInputRef.current.click();
  };
  // const quillModules = {
  //   toolbar: {
  //     container: [['bold', 'italic', 'underline', 'strike', 'clean', 'link', 'image']],
  //     handlers: {
  //       image: handleAttach,
  //     }
  //   },
  //   clipboard: {
  //     matchVisual: false, 
  //   }
  // };
 
const quillModules = {
  toolbar: {
    container: [['bold', 'italic', 'underline', 'strike', 'clean', 'link', 'image']],
    handlers: {
      image: handleAttach,
    }
  },
  clipboard: {
    matchVisual: false,
  },
  history: {
    delay: 500,
    maxStack: 100,
    userOnly: true
  },
  keyboard: {
    bindings: {
      handleEnter: {
        key: 13,
        shiftKey: false,
        handler: function (range, context) {
          handleSend();
          return false;
        }
      },
      shiftEnter: {
        key: 13,
        shiftKey: true,
        handler: function (range, context) {
          const cursorPosition = range.index;
          this.quill.insertText(cursorPosition, '\n');
          this.quill.setSelection(cursorPosition + 1);
          return false;
        }
      },
      undo: {
        key: 'z',
        shortKey: true,
        handler: function () {
          this.quill.history.undo();
        }
      },
      redo: {
        key: 'z',
        shortKey: true,
        shiftKey: true,
        handler: function () {
          this.quill.history.redo();
        }
      }
    }
  }
};




 
  const sendMessage = () => {
    const newMessage = { conversationId, message, sender: user, senderId: user.user_id,participants,selectedChatLogId,domain:DOMAIN };
    socketRef.current?.emit("message", newMessage);
    setMessage("");
    clearTimeout(typingTimeout.current);
    socketRef.current?.emit("stop typing", { conversationId, senderId: user.user_id,domian:DOMAIN });
  };

  const handleSend = () => {
    let cleanedMessage = message.replace(/<p><br><\/p>/g, '').trim();
    if (!cleanedMessage && !image) return;
    if (editingMessage?.id) {
      // Emit edit via socket for instant updates (like send)
      socketRef.current?.emit("edit-message", {
        conversationId,
        senderId: user.user_id,
        messageId: editingMessage.id,
        message: cleanedMessage || '',
        selectedChatLogId,
        participants,
        domain: DOMAIN
      });
      clearTimeout(typingTimeout.current);
      socketRef.current?.emit("stop typing", {
        conversationId,
        senderId: user.user_id,
        participants,
        domain: DOMAIN
      });

      if (onEdit) {
        onEdit({
          conversationId,
          messageId: editingMessage.id,
          message: cleanedMessage || '',
          contentType: 'text',
          attachment: null,
          createdAt: new Date(),
          senderId: user?.user_id
        });
      }
      setMessage('');
      setImage('');
      setOpenImagePreview(false);
      return;
    }

    sendMessage();
    if (onSend) {
      onSend({
        conversationId,
        messageId: faker.datatype.uuid(),
        message:cleanedMessage || '',
        contentType: image ? 'image' : 'text',
        attachment: image,
        createdAt: new Date(),
        senderId: user?.user_id
      });
    }
    setMessage(prev => prev.replace(/<p>/g, '').replace(/<\/p>/g, '').trim());
    setImage('');
    setOpenImagePreview(false);
  };
  const handleSendStickers = (messageContent = message, attachmentUrl = null) => {
    if (!messageContent.trim() && !attachmentUrl) return;

    sendMessage();

    if (onSend) {
      onSend({
        conversationId,
        messageId: faker.datatype.uuid(),
        message: messageContent,
        contentType: attachmentUrl ? 'gif' : image ? 'image' : 'text',
        attachment: attachmentUrl || image || '',
        createdAt: new Date(),
        senderId: user?.user_id
      });
    }

    setMessage('');
    setImage('');
    setOpenImagePreview(false);
};

  // const handleFileChange = async (event) => {
  //   const file = event.target.files[0];
  //   if (!file) return;
  //   event.target.value = '';
  //   const filename = new Date().getTime() + file.name;
  //   const storageRef = imageref(storage, filename);
  //   const uploadTask = uploadBytesResumable(storageRef, file);
    
  //   uploadTask.on(
  //     "state_changed",
  //     () => setProgress(true),
  //     (error) => {
  //       console.error(error.message);
  //       setProgress(false);
  //       enqueueSnackbar("Please upload an image less than 1 GB", { variant: "error" });
  //     },
  //     () => {
  //       getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
  //         setImagePreview(downloadURL);
  //         setImage(downloadURL); 
  //         setOpenImagePreview(!openImagePreview);
  //         // setMessage(prevMessage => `${prevMessage}<img src="${downloadURL}" alt="uploaded image" style="max-width: 100%; height: auto;"/>`);
  //         setProgress(false);
  //       });
  //     }
  //   );
  // };
  
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    event.target.value = '';
    const filename = `${Date.now()}_${file.name.replace(/\s+/g, '_')}`;
    const filePath = `chat-signwise/attachments/${filename}`;

    try {
      setProgress(true);

      const { error: uploadError } = await supabase.storage
        .from('signwise-attachments')
        .upload(filePath, file);

      if (uploadError) throw uploadError;

      const { data: publicUrlData, error: urlError } = supabase.storage
        .from('signwise-attachments')
        .getPublicUrl(filePath);

      if (urlError || !publicUrlData?.publicUrl) {
        throw new Error('Failed to get public URL');
      }

      const downloadURL = publicUrlData.publicUrl;

      setImagePreview(downloadURL);
      setImage(downloadURL);
      setOpenImagePreview((prev) => !prev);
      setProgress(false);
    } catch (error) {
      console.error('Upload failed:', error.message);
      setProgress(false);
      enqueueSnackbar("Please upload an image less than 1 GB", { variant: "error" });
    }
  };

const handleCloseModal = () => {
    setOpenImagePreview(false);
    setImagePreview('');
    setImage('');
    setMessage('');
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const isMessageValid = (msg) => {
  const hasText = msg.replace(/<(.|\n)*?>/g, '').trim().length > 0;
  const hasImage = /<img\s+[^>]*src="[^"]+"[^>]*>/i.test(msg);
  return hasText || hasImage;
};

  return (
    <RootStyle {...other}>
      <ReactQuill
       ref={quillRef}
        value={message}
        onChange={(val) => {
          console.log('valvalvalval 1', val)
          setMessage(val);
          const cleaned = val.replace(/<(.|\n)*?>/g, '').trim();
          // Do not emit typing while editing — receiver would show a fake "typing" bubble
          if (cleaned.length > 0 && !editingMessage?.id) {
            handleTyping();
          }
        }}
        modules={quillModules}
        placeholder="Type a message..."
        style={{ flexGrow: 1 }}
        onKeyUp={(event) => {
          if ((event.key === 'Enter' || event.keyCode === 13) && !event.shiftKey) {
            handleSend();
          }
        }}
      />
      <Divider orientation="vertical" flexItem />
      <Stack direction="row" spacing={0.5} sx={{mx:1}} alignItems='center' justifyContent='center'>
            <EmojiPickerChatSignWise disabled={disabled} value={message} setValue={setMessage} onSend={handleSendStickers}/>
           {/* message.replace(/<(.|\n)*?>/g, '').trim() */}
            {editingMessage?.id && (
              <Button size="small" onClick={() => onCancelEdit && onCancelEdit()}>
                Cancel edit
              </Button>
            )}
            <IconButton color="primary" disabled={!isMessageValid  && !image} onClick={handleSend} >
        {progress ? <CircularProgress size={15} color="primary" /> : <Icon icon={roundSend} width={24} height={24} />}
      </IconButton>
          </Stack>
      <input type="file" accept="image/*" ref={fileInputRef} onChange={handleFileChange} style={{ display: 'none' }} />
      <Dialog open={openImagePreview} onClose={handleCloseModal}>
      <DialogTitle>Image Preview</DialogTitle>
      <DialogContent 
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '10px',
            overflow: 'hidden'
          }}
        >
        <img src={imagePreview} alt="Selected" style={{ width: '100%', maxHeight: '250px', objectFit: 'contain',marginBottom:'2rem' }} />
        <RootStyle {...other}>
        <ReactQuill
          value={message}
          onChange={(val) => {
            console.log('valvalvalval 2', val)
            setMessage(val);
            const cleaned = val.replace(/<(.|\n)*?>/g, '').trim();
            if (cleaned.length > 0 && !editingMessage?.id) {
              handleTyping();
            }
          }}
          modules={quillModules}
          placeholder="Type a message..."
          style={{ marginTop: '80px', height: '200px' }}
          onKeyUp={(event) => {
            if ((event.key === 'Enter' || event.keyCode === 13) && !event.shiftKey){
              handleSend();
            }
          }}
        />
      <Stack direction="row" spacing={0.5} sx={{mx:1}} alignItems='center' justifyContent='center'>
      <Divider orientation="vertical" flexItem />
            <EmojiPickerChatSignWise disabled={disabled} value={message} setValue={setMessage} onSend={handleSendStickers}/>
            <IconButton color="primary" disabled={!message.replace(/<(.|\n)*?>/g, '').trim() && !image}  onClick={handleSend} >
        {progress ? <CircularProgress size={15} color="primary" /> : <Icon icon={roundSend} width={24} height={24} />}
      </IconButton>
          </Stack>
          </RootStyle>
      </DialogContent>
      <DialogActions sx={{ padding: '0px !important' }} >
      <Button sx={{mx:2,my:1}} onClick={handleCloseModal} color="primary">Cancel</Button>
      </DialogActions>
    </Dialog>
    </RootStyle>
  );
}
